import { NoticeBar } from 'antd-mobile';
import { closeNotic } from '@/api/service';
import { connect, history, useHistory } from 'umi';
import './index.less'
const NoticeBarHoliday = (props:any) => {
    const {loginInfo} = props
    const onClose = async () => {
        const res = await closeNotic({ id: loginInfo.announcement?.id });
      };
    return (
        <>
         {loginInfo?.announcement?.id && (
          <NoticeBar
            style={{
              '--background-color': '#F89B44',
              '--border-color': '#F89B44',
              '--text-color': '#fff',
            }}
            content={
              <div
                className="notbar"
                dangerouslySetInnerHTML={{
                  __html: loginInfo?.announcement?.content,
                }}
              />
            }
            color="alert"
            closeable
            onClose={onClose}
            className="noticbar"
          />
        )}
        </>
    )
}

export default connect(({headInfo}:any)=>{
    return{
        ...headInfo
    }
})(NoticeBarHoliday)